import { useEffect, useRef } from "react";
import styled from "styled-components";
import { Input } from "./Input";
import { Toggle } from "./Toggle";
import { spacing } from "@styling/sizing";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.x2}px;
  flex-wrap: wrap;
`;

const SearchField = styled(Input)`
  flex: 1;
  min-width: 200px;
`;

const ActiveLabel = styled.span`
  white-space: nowrap;
  color: ${colors.text};
  font-size: ${fontSizes.regular}px;
`;

interface StoreListSearchRowProps {
  query: string;
  onQueryChange: (value: string) => void;
  activeOnly: boolean;
  onToggleActiveOnly: () => void;
  placeholder: string;
  activeOnlyLabel: string;
}

export const StoreListSearchRow = ({
  query,
  onQueryChange,
  activeOnly,
  onToggleActiveOnly,
  placeholder,
  activeOnlyLabel,
}: StoreListSearchRowProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Row>
      <SearchField
        ref={inputRef}
        type="search"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
      />
      <ActiveLabel>{activeOnlyLabel}</ActiveLabel>
      <Toggle checked={activeOnly} onChange={() => onToggleActiveOnly()} />
    </Row>
  );
};
